import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23">
    <path fill="#1D1D1B" fillRule="evenodd" d="M4.418 7.2v15.04H.064V.448h3.93l13.493 15.04V.448h4.354v21.8h-3.915z" />
  </svg>
);
